import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f5ce172e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5ce172e')) {
      api.createRecord('f5ce172e', component.options)
    } else {
      api.reload('f5ce172e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f5ce172e", function () {
      api.rerender('f5ce172e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/index.vue"
export default component.exports